export interface IShipmentState {
  loading: boolean;
  postCodeCheckLoading: boolean;
  shipmentNumber: string;
  postCode: string;
}

export const initialShipmentState: IShipmentState = {
  loading: false,
  postCodeCheckLoading: false,
  shipmentNumber: '',
  postCode: '',
}